import "../layouts/login";

function checkIcdph() {
    if (document.querySelector('.js-toggle-icdph .c-form__input[type="checkbox"]').checked) {
        document.querySelector('.js-cz-dic .c-form__input').setAttribute('required', 'required');
        document.querySelector('.js-cz-dic').classList.add('is-required');
    } else {
        document.querySelector('.js-cz-dic .c-form__input').removeAttribute('required');
        document.querySelector('.js-cz-dic').classList.remove('is-required');
    }
}

$(function() {
	$('.js-form-lost-password').validate({
        submitHandler: function(form) {
            form.submit();
        }
	});

    if (document.querySelector('.js-toggle-icdph')) {
        checkIcdph();

        document.querySelector('.js-toggle-icdph .c-form__input[type="checkbox"]').addEventListener('change', event => {
            checkIcdph();
        });
    }
});